__webpack_require__.p = "https://prod.jp.safer.whs.amazon.dev/";